import { useMutation } from "@tanstack/react-query";
import {
  photoSeriesUpdate,
  PhotoSeriesUpdateParams,
} from "common/api/citajteo/photo_series/photo_series";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UsePhotoSeriesUpdateParams = {
  invalidateKeys?: string[];
  invalidateKeysArray?: string[][];
  successHandle?: Function;
  errorHandle?: Function;
};

export const usePhotoSeriesUpdate = (
  hookParams?: UsePhotoSeriesUpdateParams
) => {
  const { invalidateQueriesByKeys, invalidateQueriesArraysByKeys } =
    useInvalidateQueryByKeys();
  const { mutate: photoSeriesUpdateMutate } = useMutation({
    mutationFn: async (params: {
      id: string;
      updatePayload: PhotoSeriesUpdateParams;
    }) => {
      const response = await photoSeriesUpdate(
        params.id,
        params.updatePayload
      );

      if (!response) {
        throw new Error("photoSeriesUpdate failed");
      }

      return response;
    },
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      } else if (hookParams?.invalidateKeysArray) {
        invalidateQueriesArraysByKeys(hookParams.invalidateKeysArray);
      }

      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
    onError: (error) => {
      if (hookParams?.errorHandle) {
        hookParams.errorHandle(error);
      }
    },
  });

  return { photoSeriesUpdateMutate };
};
